import React from 'react';

const CategorySummaryOuterContainer = React.memo(({ category, children, main, secondary, classes, setCategoryAsSubgroupCategory, normalClickWillToggleDisplay, startHighlightCategory, ...props }) => {

	const ContainerComponent = 'div';
	return (
		<ContainerComponent
			className={`category_summary_outer_container
				${category.getParent() ? 'has_parent' : 'is_parent'}
				${setCategoryAsSubgroupCategory ? 'clickable' : ''}`}>
			<div
				onClick={normalClickWillToggleDisplay ? startHighlightCategory : undefined}
				className={`category_summary main row  ${classes.toString()}`}>
				{main}
				{children}
			</div>
			{secondary}
		</ContainerComponent>
	);
});

export default CategorySummaryOuterContainer;